export default __webpack_public_path__ + "static/cruiselines-vv-ship-5-3171ac769088273566aeeb301a435098.jpg";